"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var build_dep_graphs_1 = require("./build-dep-graphs");
Object.defineProperty(exports, "buildDepGraphs", { enumerable: true, get: function () { return build_dep_graphs_1.buildDepGraphs; } });
//# sourceMappingURL=index.js.map